export const commandKeys = {
    checkOutCart: "CHECK_OUT_CART",
    userLoggedIn: "USER_LOGGED_IN",
    checkCartItems: "CHECK_CART_ITEMS",
    clearCartItems: "CLEAR_CART_ITEMS",
    addProductToCart: "ADD_PRODUCT_TO_CART",
    removeAddToCartButton: "REMOVE_ADD_TO_CART_BUTTON",
    enableAddToCartButton: "ENABLE_ADD_TO_CART_BUTTON",
    windowStateChange: "WIDGET_WINDOW_STATE_CHANGE",
    checkoutCart: "CHECKOUT_CART_ITEMS",
    addToCartButtonDetected: "ADD_TO_CART_BUTTON_DETECTED",
    widgetInitialized: "WIDGET_INITIALIZATION_FINISHED",
    removeHashKey: "REMOVE_HASH_KEY",
    updateMyCartButtonText: "UPDATE_MY_CART_BUTTON_TEXT",
    createNewGroupOrder: "CREATE_NEW_GROUP_ORDER",
    invitationAccepted: "INVITATION_ACCEPTED",
    checkProductCartCapability: "CHECK_PRODUCT_CART_CAPABILITY",
    moneyFormatChange: "MONEY_FORMAT_CHANGE",
    getLocation: "GET_LOCATION",
    getTranslations: "GET_TRANSLATION"
};



// WEBPACK FOOTER //
// ./src/shared/commandKeys.js